import React  from "react";
import { connect } from "react-redux";
import { 
    Users,
    TrendingUp,
    Trophy,
    Activity,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import EmployeeDashBoard from "./components/EmployeeDashBoard";

const PerformanceImprovement = () => {
    
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6">
                <SummaryHeader
                    title={"Performance Improvement"}
                    icon={TrendingUp}
                    description={"Track employee development with measurable milestones"}
                    color={"purple"}
                >
                    <div className="summary-item-container">
                        <SummaryItem
                            title="Active Programs"
                            icon={<Users />}
                            display="3"
                        />
                        <SummaryItem
                            title="Avg. Improvement"
                            icon={<Trophy />}
                            display="+10%" 
                        />
                        <SummaryItem
                            title="Completion Rate"
                            icon={<Activity />}
                            display="65%" 
                        />
                    </div>
                </SummaryHeader>
                <>
                    <EmployeeDashBoard />
                </>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceImprovement);